import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronLeft, ChevronRight } from 'lucide-react';
const images = ['https://cdn.magicpatterns.com/uploads/81gZtoZR3hwCQqaJhCHkEa/Screenshot_2026-06-19_at_9.22.52_PM.png', 'https://cdn.magicpatterns.com/uploads/eudnZN8vbMGRPYuzYLkqaL/Screenshot_2026-06-19_at_9.23.03_PM.png', 'https://cdn.magicpatterns.com/uploads/b7XXNanuL8k23wbCbD2vJm/Screenshot_2026-06-19_at_9.23.18_PM.png', 'https://cdn.magicpatterns.com/uploads/fLsACu5VPbhL2m3qRHU73r/Screenshot_2026-06-19_at_9.24.18_PM.png'];
export const Carousel = () => {
  const [index, setIndex] = useState(0);
  const [direction, setDirection] = useState(0);
  const paginate = (newDirection: number) => {
    setDirection(newDirection);
    setIndex(prev => (prev + newDirection + images.length) % images.length);
  };
  const goTo = (i: number) => {
    setDirection(i > index ? 1 : -1);
    setIndex(i);
  };
  return <div className="max-w-md mx-auto" data-id="element-245">
      <div className="relative bg-white rounded-xl overflow-hidden border border-slate-700/50 shadow-2xl shadow-black/40 aspect-square" data-id="element-246">
        <AnimatePresence initial={false} custom={direction} mode="popLayout" data-id="element-247">
          <motion.img key={index} src={images[index]} alt={`Vista previa ${index + 1} del contenido`} custom={direction} initial={{
          opacity: 0,
          x: direction > 0 ? 60 : -60
        }} animate={{
          opacity: 1,
          x: 0
        }} exit={{
          opacity: 0,
          x: direction > 0 ? -60 : 60
        }} transition={{
          duration: 0.25
        }} className="absolute inset-0 w-full h-full object-contain bg-white" draggable={false} data-id="element-248" />
        </AnimatePresence>

        <button onClick={() => paginate(-1)} aria-label="Anterior" className="absolute left-2 top-1/2 -translate-y-1/2 bg-black/40 hover:bg-black/60 text-white rounded-full p-2 transition-colors backdrop-blur-sm" data-id="element-249">
          <ChevronLeft className="w-5 h-5" data-id="element-250" />
        </button>
        <button onClick={() => paginate(1)} aria-label="Siguiente" className="absolute right-2 top-1/2 -translate-y-1/2 bg-black/40 hover:bg-black/60 text-white rounded-full p-2 transition-colors backdrop-blur-sm" data-id="element-251">
          <ChevronRight className="w-5 h-5" data-id="element-252" />
        </button>

        <div className="absolute top-3 right-3 bg-black/50 text-white text-xs font-medium px-2 py-1 rounded-full backdrop-blur-sm" data-id="element-253">
          {index + 1}/{images.length}
        </div>
      </div>

      <div className="flex items-center justify-center gap-2 mt-4" data-id="element-254">
        {images.map((_, i) => <button key={i} onClick={() => goTo(i)} aria-label={`Ir a la imagen ${i + 1}`} className={`h-2 rounded-full transition-all ${i === index ? 'w-6 bg-[#f0b429]' : 'w-2 bg-slate-600 hover:bg-slate-500'}`} data-id="element-255" />)}
      </div>
    </div>;
};